import {
    CONFIRM_PAYSLIPS_IMPORT_FAILURE,
    CONFIRM_PAYSLIPS_IMPORT_REQUEST,
    CONFIRM_PAYSLIPS_IMPORT_SUCCESS,
    FETCH_MY_PAYSLIPS_FAILURE,
    FETCH_MY_PAYSLIPS_REQUEST,
    FETCH_MY_PAYSLIPS_SUCCESS,
    FETCH_PAYSLIP_COVERAGE_FAILURE,
    FETCH_PAYSLIP_COVERAGE_REQUEST,
    FETCH_PAYSLIP_COVERAGE_SUCCESS,
    PREVIEW_PAYSLIPS_FAILURE,
    PREVIEW_PAYSLIPS_REQUEST,
    PREVIEW_PAYSLIPS_SUCCESS,
    REMOVE_PAYSLIP_PREVIEW_LINE,
    RESET_PAYSLIP_IMPORT,
    SET_PAYSLIP_LOADING,
    SET_PAYSLIP_SELECTED_FILES,
    SET_PAYSLIP_STEP,
} from "../actions/payslipActions";

const initialState = {
    selectedFiles: [],
    previewRows: [],
    myPayslips: [],
    coverage: null,
    coverageError: null,
    loading: false,
    loadingAction: null,
    error: null,
    successMessage: "",
    confirmSummary: null,
    currentStep: 0,
};

const payslipReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PAYSLIP_LOADING:
            return {
                ...state,
                loading: !!action.payload,
                loadingAction: action.payload,
            };

        case SET_PAYSLIP_SELECTED_FILES:
            return {
                ...state,
                selectedFiles: action.payload || [],
                previewRows: [],
                error: null,
                successMessage: "",
                confirmSummary: null,
                currentStep: 0,
            };

        case SET_PAYSLIP_STEP:
            return {
                ...state,
                currentStep: action.payload,
            };

        case PREVIEW_PAYSLIPS_REQUEST:
            return {
                ...state,
                loading: true,
                loadingAction: "preview",
                error: null,
                successMessage: "",
                confirmSummary: null,
                currentStep: 1,
            };

        case PREVIEW_PAYSLIPS_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingAction: null,
                previewRows: action.payload || [],
                error: null,
                currentStep: 2,
            };

        case PREVIEW_PAYSLIPS_FAILURE:
            return {
                ...state,
                loading: false,
                loadingAction: null,
                error: action.payload,
            };

        case CONFIRM_PAYSLIPS_IMPORT_REQUEST:
            return {
                ...state,
                loading: true,
                loadingAction: "confirm",
                error: null,
                successMessage: "",
                currentStep: 3,
            };

        case CONFIRM_PAYSLIPS_IMPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingAction: null,
                selectedFiles: [],
                previewRows: [],
                error: null,
                successMessage: action.payload?.message || "",
                confirmSummary: action.payload,
                currentStep: 3,
            };

        case CONFIRM_PAYSLIPS_IMPORT_FAILURE:
            return {
                ...state,
                loading: false,
                loadingAction: null,
                error: action.payload,
            };

        case FETCH_MY_PAYSLIPS_REQUEST:
            return {
                ...state,
                loading: true,
                loadingAction: "list",
                error: null,
            };

        case FETCH_MY_PAYSLIPS_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingAction: null,
                myPayslips: action.payload || [],
                error: null,
            };

        case FETCH_MY_PAYSLIPS_FAILURE:
            return {
                ...state,
                loading: false,
                loadingAction: null,
                error: action.payload,
            };

        case FETCH_PAYSLIP_COVERAGE_REQUEST:
            return {
                ...state,
                loading: true,
                loadingAction: "coverage",
                coverageError: null,
            };

        case FETCH_PAYSLIP_COVERAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingAction: null,
                coverage: action.payload,
                coverageError: null,
            };

        case FETCH_PAYSLIP_COVERAGE_FAILURE:
            return {
                ...state,
                loading: false,
                loadingAction: null,
                coverageError: action.payload,
            };

        case REMOVE_PAYSLIP_PREVIEW_LINE: {
            const previewRows = (state.previewRows || []).filter((row) => row.tempId !== action.payload);

            return {
                ...state,
                previewRows,
                currentStep: previewRows.length ? state.currentStep : 0,
            };
        }

        case RESET_PAYSLIP_IMPORT:
            return {
                ...initialState,
                myPayslips: state.myPayslips,
                coverage: state.coverage,
            };

        default:
            return state;
    }
};

export default payslipReducer;
